/** Full-screen brand splash while the session loads (or for a fatal boot error). */
import type { ReactNode } from 'react';
import { Spinner } from '../components/Spinner.js';
import styles from './Splash.module.css';

export function Splash({ children }: { children?: ReactNode }) {
  return (
    <div className={styles.splash}>
      <img className={styles.icon} src="/brand/transect-icon.svg" alt="" width={72} height={72} />
      {children ?? <Spinner size={24} label="TransectLibre wordt geladen…" />}
    </div>
  );
}
